import { Component, Inject, Injector } from "@angular/core";
import { Vision } from "@common/ADAPT.Common.Model/organisation/vision";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { ADAPT_DIALOG_DATA } from "@common/ux/adapt-common-dialog/adapt-common-dialog.globals";
import { BaseDialogWithDiscardConfirmationComponent } from "@common/ux/adapt-common-dialog/base-dialog-with-discard-confirmation.component/base-dialog-with-discard-confirmation.component";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";
import { forkJoin, switchMap } from "rxjs";
import { VisionService } from "../vision.service";
import { VisionAuthService } from "../vision-auth.service";

@Component({
    selector: "adapt-assign-integrated-vision-dialog",
    standalone: false,
    templateUrl: "./assign-integrated-vision-dialog.component.html",
})
export class AssignIntegratedVisionDialogComponent extends BaseDialogWithDiscardConfirmationComponent<number, Vision[]> {
    public readonly dialogName = "AssignIntegratedVisionDialog";
    public assignedPerson?: Person;

    private integratedVisions: Vision[] = [];
    private teamMembers: Person[] = [];

    public constructor(
        injector: Injector,
        @Inject(ADAPT_DIALOG_DATA) private teamId: number,
        private visionService: VisionService,
        private visionAuthService: VisionAuthService,
        teamsService: CommonTeamsService,
    ) {
        super(injector);

        forkJoin([
            this.visionService.getIntegratedVisionsByTeam(teamId),
            teamsService.getTeamById(teamId).pipe(
                switchMap((team) => teamsService.promiseToGetActiveTeamMembers(team!))),
        ]).pipe(
            this.takeUntilDestroyed(),
        ).subscribe(([visions, members]) => {
            this.assignedPerson = visions[0]?.person;
            this.integratedVisions = visions;
            this.autoResolveData = visions;
            this.teamMembers = members;
            this.isInitialised = true;
        });
    }

    public get entitiesToConfirm() {
        return this.integratedVisions;
    }

    @Autobind
    public teamMembersOnly(person: Person) {
        return this.teamMembers.some((tm) => tm.personId === person.personId) &&
            this.visionAuthService.personCanEditVisionForTeamId(person, this.teamId);
    }

    public assignVisionTo(person?: Person) {
        this.assignedPerson = person;
        this.integratedVisions.forEach((v) => v.personId = person?.personId);
    }
}
